import { useEffect, useRef } from "react";
import * as echarts from "echarts";
import {
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
} from "echarts/components";
import { HeatmapChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  HeatmapChart,
  CanvasRenderer,
]);

const FrecMapChartComponent = ({ datos, caracteristica }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current || typeof datos !== "object" || datos === null)
      return;

    const myChart = echarts.init(chartRef.current);

    const amenazas = [
      { id: 156, nombre: "Participar en\ninteracciones\nengañosas" },
      { id: 210, nombre: "Abusar de\nfuncionalidad\nexistente" },
      { id: 255, nombre: "Manipular\nestructuras\nde datos" },
      { id: 262, nombre: "Manipular\nrecursos\ndel sistema" },
      { id: 152, nombre: "Inyectar\nelementos\ninesperados" },
      { id: 223, nombre: "Emplear\ntécnicas\nprobabilísticas" },
      { id: 172, nombre: "Manipular la\nsincronización\ny el estado" },
      { id: 118, nombre: "Recopilar y\nanalizar\ninformación" },
      { id: 225, nombre: "Alterar el\ncontrol\nde acceso" },
      { id: 1000, nombre: "Categoría\nvirtual" },
    ];

    const amenazaNombres = amenazas.map((a) => a.nombre);
    const amenazaIDs = amenazas.map((a) => a.id.toString());

    // Construcción de data en formato [x, y, value]
    const data = amenazas.map((amenaza, xIndex) => {
      const valor =
        typeof datos[amenaza.id] === "number" && !isNaN(datos[amenaza.id])
          ? datos[amenaza.id]
          : 0;
      return [xIndex, 0, valor];
    });

    const valores = Object.values(datos).filter(
      (v) => typeof v === "number" && !isNaN(v)
    );
    const maxValor = valores.length > 0 ? Math.max(...valores) : 1;

    const option = {
      tooltip: {
        position: "top",
      },
      grid: {
        height: "20%",
        top: "20%",
      },
      xAxis: {
        type: "category",
        data: amenazaNombres,
        splitArea: {
          show: true,
        },
      },
      yAxis: {
        type: "category",
        data: [caracteristica],
        splitArea: {
          show: true,
        },
      },
      visualMap: {
        show: false,
        min: 0,
        max: maxValor,
        calculable: true,
        orient: "horizontal",
        left: "center",
        bottom: "10%",
      },
      series: [
        {
          type: "heatmap",
          data: data,
          label: {
            show: true,
            formatter: ({ value }) => value[2].toFixed(2),
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };

    myChart.setOption(option);
    window.addEventListener("resize", () => myChart.resize());

    return () => {
      window.removeEventListener("resize", () => myChart.resize());
      myChart.dispose();
    };
  }, [datos, caracteristica]);

  return <div ref={chartRef} style={{ width: "85vw", height: "40vh" }} />;
};

export default FrecMapChartComponent;
